import type { VaultLatestProfile } from '@ducat-unit/core';

import { wait } from '@/lib/util';

import { get } from './http';

/** Called only after the submitted close transaction has confirmed. */
export async function poll_closed_vault(
  root_txid: string,
  client_pubkey: string,
  validator_url: string,
  signal?: AbortSignal,
  timeout_ms = 10 * 60_000,
  canReadVaultHistory?: () => boolean,
) {
  const started = Date.now();
  while (true) {
    if (signal?.aborted) throw new DOMException('Polling cancelled', 'AbortError');
    if (canReadVaultHistory?.() === false) return;
    const vault = await get<VaultLatestProfile>(`${validator_url}/api/vault/${encodeURIComponent(root_txid)}/latest`, undefined, {
      signal,
    });
    if (signal?.aborted) throw new DOMException('Polling cancelled', 'AbortError');
    if (canReadVaultHistory?.() === false) return;
    if (vault.root_txid !== root_txid || vault.client_pubkey !== client_pubkey) {
      throw new Error('Closed vault identity mismatch');
    }
    if (vault.state !== 'active' && vault.state !== 'closed') throw new Error('Vault state cannot confirm closure');
    if (
      vault.state === 'closed' &&
      vault.vault_action === 'close' &&
      vault.coin_id === null &&
      vault.vault_script === null &&
      vault.vault_value === null &&
      vault.vault_balance === 0 &&
      vault.unit_balance === 0
    )
      return;
    if (Date.now() - started >= timeout_ms) throw new Error(`Timeout: vault ${root_txid} is not closed`);
    await wait(3000, signal);
  }
}
